import 'rev-less/main.less';
import 'rev-less/video/video-main.less';
import '../embed.less';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';

import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { UtilAngularModule } from 'rev-shared/util/UtilAngular.Module';
import { VBrickSharedPublicVideoPasswordModule } from 'rev-shared/media/publicVideoPassword/PublicVideoPassword.Module';
import { VbrickSharedMediaModule } from 'rev-shared/media/Media.Module';
import { VideoPlaylistModule } from 'rev-shared/media/videoPlaylist/VideoPlaylist.Module';
import { VideoPlayerAngularModule } from 'rev-shared/videoPlayer/VideoPlayerAngular.Module';

import { EmbedVideo } from './EmbedVideo.Component';
import { EmbedFullVodPlaybackComponent } from './EmbedFullVodPlayback.Component';

const declarations = [
	EmbedVideo,
	EmbedFullVodPlaybackComponent
];

@NgModule({
	declarations,
	exports: declarations,
	imports: [
		CommonModule,
		DirectivesAngularModule,
		PushModule,
		SpinnerAngularModule,
		TooltipModule,
		TranslateModule,
		UtilAngularModule,
		UIRouterModule,
		VbrickSharedMediaModule,
		VBrickSharedPublicVideoPasswordModule,
		VideoPlaylistModule,
		VideoPlayerAngularModule
	]
})
export class EmbedVideoModule { }
